import React from 'react';
import { connect } from 'react-redux';
import Form from '../../FormsTemplate';
import { FormNames } from '../../Forms.constants';

import UserInfoSection from '../../Sections/UserInfoSection/UserInfoSection';
import ManufacturerModelSection from '../../Sections/ManufacturerModelSection/ManufacturerModelSection';
import HMISection from '../../Sections/HMISection/HMISection';
import VisualInspectSection from '../../Sections/VisualInspectSection/VisualInspectSection';
import AsFoundTestTableSection from '../../Sections/AsFoundTestTableSection/AsFoundTestTableSection';
import AsLeftTestTableSection from '../../Sections/AsLeftTestTableSection/AsLeftTestTableSection';
import ValveSizeTravelSection from '../../Sections/ValveSizeTravelSection/ValveSizeTravelSection';
import ValveSizeSection from '../../Sections/ValveSizeSection/ValveSizeSection';
import NoteSection from '../../Sections/NoteSection/NoteSection';
import FailureModeSection from '../../Sections/FailureModeSection/FailureModeSection';
import BorderedBox from '../../BorderedBox';
import AttentionLabel from '../../Sections/AttentionLabel/AttentionLabel';

const P716Form = (props) => (
    <Form
        formName={FormNames.P716}
    >
        <AttentionLabel />
        <UserInfoSection />
        <ManufacturerModelSection />
        <HMISection />
        <VisualInspectSection />
        <ValveSizeTravelSection />
        <BorderedBox>
            <AsFoundTestTableSection />
        </BorderedBox>
        <FailureModeSection />
        <BorderedBox>
            <AsLeftTestTableSection />
        </BorderedBox>
        <ValveSizeSection />
        <NoteSection />
    </Form>
);

const mapStateToProps = ({ Forms }) => ({
    selectedTag: Forms.selectedTag,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P716Form);
